import { Backdrop, Box } from "@mui/material";
import React from "react";
import { bool, element } from "prop-types";

function BackdropWrap({ open, children = null }) {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {children}
      </Box>
    </Backdrop>
  );
}

BackdropWrap.propTypes = {
  open: bool.isRequired,
  // eslint-disable-next-line react/require-default-props
  children: element
};

export default BackdropWrap;
